import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseHoursReportsKey } from '@/hooks'
import { HoursReport, APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostHoursReportDisapprove = ({
  id,
}: Pick<HoursReport, 'id'>): UseMutationResult<
  HoursReport,
  APIErrorResponse,
  unknown
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const hoursReportsListKey = getUseHoursReportsKey()

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/${id}/disapprove/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(hoursReportsListKey)
      },
    }
  )
}
